<template>
  <div class="guideTofollowImg">
    <img src="../../assets/guide_background_prod.png" />
  </div>
</template>
<script>
export default {
  data () {
    return {
      title: this.$route.query.title,
    }
  },
  mounted () {
    document.title = this.title
  },
  methods: {
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/forceToFollow.vue